export const tabs = [{ label: 'Home', value: 'home' }]
